<template>
  <v-card>
    <v-card-title class="justify-center">
        <v-btn
            v-if="step !== 1"
            icon
            color="info"
            @click="step = 1, projeto = {}"
        >
            <v-icon>west</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <h1 style="font-size: 1.8em;">
            GERENCIAR PROJETOS FIREBASE
        </h1>
        <v-spacer></v-spacer>
        <v-btn
            v-if="step === 1"
            icon
            color="info"
            @click="step = 2, pegarRedes(), pegarEmpresas()"
        >
            <v-icon>add</v-icon>
        </v-btn>
        <v-spacer v-else></v-spacer>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
        <v-stepper
            v-model="step"
            class="ma-0 pa-0"
            style="box-shadow: none;"
        >
            <v-stepper-items
                class="ma-0 pa-0"
            >

                <v-stepper-content
                    step="1"
                    class="ma-0 pa-0"
                >
                    <v-data-table
                      :headers="headers"
                      :items="projetos"
                      :loading="loading"
                      :pagination.sync="pagination"
                      :total-items="totalItens"
                      hide-actions
                    >
                        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                        <template slot="items" slot-scope="props">
                            <td>
                                {{
                                    props.item.nome_rede ?
                                        `Rede ${props.item.nome_rede}`
                                        :
                                        props.item.empresa ?
                                            `Empresa ${props.item.nome_empresa}`
                                            :
                                            'Não possui'
                                }}
                            </td>
                            <td class="text-xs-left">{{ props.item.codigo }}</td>
                            <td class="text-xs-left">{{ props.item.versao_app }}</td>
                            <td class="text-xs-left">
                                <v-tooltip bottom>
                                    <v-btn
                                        icon
                                        flat
                                        color="info"
                                        slot="activator"
                                        @click="prepararProjeto(props.item)"
                                    >
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                    <span>Editar Projeto</span>
                                </v-tooltip>
                                <v-menu
                                    offset-x
                                    left
                                    transition="slide-x-reverse-transition"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon flat color="error" v-on="on">
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card
                                        width="30em"
                                        style="
                                            border-radius: 1em;
                                        "
                                    >
                                        <v-card-title class="justify-center">
                                            <h2>Tem certeza que deseja Excluir?</h2>
                                        </v-card-title>
                                        <v-card-actions class="justify-space-around">
                                            <v-btn
                                                round
                                                small
                                            >
                                                Não
                                            </v-btn>
                                            <v-btn
                                                round
                                                small
                                                color="error"
                                                @click="excluirProjetoFirebase(props.item)"
                                            >
                                                Sim
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-menu>
                                <v-tooltip bottom>
                                    <span>Apagar Projeto</span>
                                </v-tooltip>
                            </td>
                        </template>
                    </v-data-table>
                </v-stepper-content>
                <v-stepper-content
                    step="2"
                    class="ma-0 pa-0 justify-space-around"
                >
                    <v-form lazy-validation v-model="valido" ref="formulario">
                        <v-autocomplete
                            :items="redes"
                            item-text="nome"
                            item-value="id_rede"
                            v-model="projeto.rede"
                            :disabled="!!projeto.empresa"
                            label="Rede Responsável"
                            clearable
                        >
                        </v-autocomplete>
                        <v-autocomplete
                            :items="empresas"
                            item-text="nome_fantasia"
                            item-value="cnpj"
                            :disabled="!!projeto.rede"
                            v-model="projeto.empresa"
                            label="Empresa Responsável"
                            clearable
                        ></v-autocomplete>
                        <v-text-field
                            v-if="projeto.id"
                            label="Versão do app"
                            v-model="projeto.versao_app"
                            required
                            :rules="[
                                v => !!v || 'Esse campo é obrigatório'
                            ]"
                         ></v-text-field>
                         <v-text-field
                            v-if="!projeto.id"
                            label="Project_id"
                            v-model="projeto.project_id"
                            required
                            :rules="[
                                v => !!v || 'Esse campo é obrigatório'
                            ]"
                         ></v-text-field>
                         <v-text-field
                            v-if="!projeto.id"
                            label="Private_key_id"
                            v-model="projeto.private_key_id"
                            required
                            :rules="[
                                v => !!v || 'Esse campo é obrigatório'
                            ]"
                         ></v-text-field>
                         <v-text-field
                            v-if="!projeto.id"
                            label="Remetente_id"
                            v-model="projeto.remetente_id"
                            required
                            :rules="[
                                v => !!v || 'Esse campo é obrigatório'
                            ]"
                         ></v-text-field>
                         <v-textarea
                            v-if="!projeto.id"
                            label="Private_key"
                            v-model="projeto.private_key"
                            required
                            :rules="[
                                v => !!v || 'Esse campo é obrigatório'
                            ]"
                         ></v-textarea>
                         <v-text-field
                            v-if="!projeto.id"
                            label="Client_email"
                            v-model="projeto.client_email"
                            required
                            :rules="[
                                v => !!v || 'Esse campo é obrigatório'
                            ]"
                         ></v-text-field>
                         <v-text-field
                            v-if="!projeto.id"
                            label="Client_id"
                            v-model="projeto.client_id"
                            required
                            :rules="[
                                v => !!v || 'Esse campo é obrigatório'
                            ]"
                         ></v-text-field>
                         <v-text-field
                            v-if="!projeto.id"
                            label="client_x509_cert_url"
                            v-model="projeto.client_x509_cert_url"
                            required
                            :rules="[
                                v => !!v || 'Esse campo é obrigatório'
                            ]"
                         ></v-text-field>
                    </v-form>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </v-card-text>
    <v-card-actions class="ma-0 pa-0">
        <v-btn
            block
            large
            color="info"
            @click="function () {
                return step === 1 ?
                voltar() :
                projeto.id ?
                editarProjetoFirebase() :
                adicionarProjetoFirebase()
            }"
        >
            <b>
                {{
                    step === 1 ? 'Fechar' : 'Salvar'
                }}
            </b>
        </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { aesKey, iv } from '@/keys.json'
const CryptoJS = require('crypto-js')
export default {
    data: () => ({
        step: 1,
        pagination: {
            page: 1,
            rowsPerPage: 5
        },
        headers: [
            {
                text: 'Responsável',
                sortable: false,
                align: 'left'
            },
            {
                text: 'Código',
                sortable: false,
                align: 'left'
            },
            {
                text: 'Versão',
                sortable: false,
                align: 'left'
            },
            {
                sortable: false,
                align: 'left'
            }
        ],
        projetos: [],
        totalItens: 0,
        projeto: {},
        redes: [],
        empresas: [],
        nome_rede: undefined,
        valido: false
    }),
    computed: {
        loading () {
            return this.$store.getters.loading
        },
        pages () {
            if (this.pagination.rowsPerPage == null || this.totalItens == null) {
                return 0
            }
            return Math.ceil(this.totalItens / this.pagination.rowsPerPage)
        }
    },
    beforeMount () {
        this.pegarProjetosFirebase()
    },
    watch: {
        'pagination.page' (val) {
            if (val) {
                this.pegarProjetosFirebase()
            }
        }
    },
    methods: {
        voltar () {
            if (this.step === 1) this.$emit('fechar')
            else this.step = 1
        },
        prepararProjeto (projeto) {
            this.pegarRedes(projeto.rede)
            this.pegarEmpresas(projeto.empresa)
            this.projeto = projeto
            this.step = 2
        },
        adicionarProjetoFirebase () {
            if (this.$refs.formulario.validate()) {
                var ciphertext = CryptoJS.AES.encrypt(JSON.stringify({
                    project_id: this.projeto.project_id.trim(),
                    private_key_id: this.projeto.private_key_id.trim(),
                    remetente_id: this.projeto.remetente_id.trim(),
                    private_key: this.projeto.private_key.trim(),
                    client_email: this.projeto.client_email.trim(),
                    client_id: this.projeto.client_id.trim(),
                    client_x509_cert_url: this.projeto.client_x509_cert_url.trim(),
                    rede: this.projeto.rede,
                    empresa: this.projeto.empresa
                }),
                    CryptoJS.enc.Utf8.parse(aesKey),
                    {
                    iv: CryptoJS.enc.Utf8.parse(iv),
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                    }).toString()
                this.$store.dispatch('projetosFirebase', {
                    method: 'POST',
                    body: {
                        projeto_criptografado: ciphertext
                    }
                }).then(() => {
                    this.pegarProjetosFirebase()
                    this.voltar()
                })
            } else {
                console.error('Fumulário inválido')
            }
        },
        excluirProjetoFirebase (projeto) {
            this.$store.dispatch('projetosFirebase', {
                method: 'DELETE',
                id: projeto.id
            }).then(() => {
                this.pegarProjetosFirebase()
            })
        },
        editarProjetoFirebase () {
            this.$store.dispatch('projetosFirebase', {
                method: 'PATCH',
                id: this.projeto.id,
                body: {
                    versao_app: this.projeto.versao_app,
                    rede: this.projeto.rede,
                    empresa: this.projeto.empresa
                }
            }).then(() => {
                this.pegarProjetosFirebase()
                this.voltar()
            })
        },
        pegarProjetosFirebase () {
            this.$store.dispatch('projetosFirebase', {
                method: 'GET',
                body: {
                    page: this.pagination.page
                }
            }).then(json => {
                this.projetos = json.results
                this.totalItens = json.count
            })
        },
        pegarRedes (idRede = undefined) {
            const data = {}
            if (idRede) data.rede = idRede
            if (this.nome_rede) data.nome__icontains = this.nome_rede
            this.$store.dispatch('pegarTodasRedes', data).then(json => {
                this.redes = json
            })
        },
        pegarEmpresas (idEmpresa = undefined) {
            const data = {
                ativo: true
            }
            if (idEmpresa) data.cnpj = idEmpresa
            this.$store.dispatch('procurarEmpresasPorAdm', { filtros: data }).then(json => {
                this.empresas = json
            })
        }
    }
}
</script>

<style>

</style>
